<template>
  <div>
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="姓名"
        maxlength="50"
        v-model="searchData.ExamineeName"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.DeptId"
        size="small"
        :placeholder="`${$t('所属部门')}`"
        class="mr-10px !w-50"
        clearable
        filterable
      >
        <el-option
          v-for="(item, index) in departmentList"
          :key="index"
          :label="item.displayName"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-if="isHasExamed !== 1"
        v-model="searchData.IsPass"
        size="small"
        :placeholder="`${$t('是否通过')}`"
        class="mr-10px !w-50"
        clearable
      >
        <el-option
          v-for="(item, index) in passList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <!-- <el-button
        v-if="isHasExamed !== 1"
        size="small"
        type="primary"
        @click="download(item.sessionName)"
        >下载试卷</el-button
      > -->
      <el-button 
        v-if="isHasExamed !== 1" 
        size="small" 
        type="primary" 
        @click="downloadGrades"
        :loading="loading"
        >下载成绩单</el-button
      >
    </div>
    <el-table
      v-if="!loading"
      :data="studentList"
      class="w-full"
      height="calc(100% - 56px)"
      border
      stripe
      v-loading="loading"
      @selection-change="selectionChange"
    >
      <el-table-column
        v-if="isHasExamed !== 1"
        type="selection"
        width="55"
        align="center"
      ></el-table-column>

      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="考生姓名" prop="ExamineeName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="所属部门"
        prop="DeptName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="isHasExamed !== 1"
        label="得分"
        prop="customerScore"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column v-if="isHasExamed !== 1" label="是否通过" prop="pass" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.pass ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isHasExamed !== 1" label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="viewInfo(scope.row)">查看试卷</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'ExamRecordCommon',
  props: { 
    studentList: {
      type: Array,
      default: () => {
        return []
      },
    },
    departmentList: {
      type: Array,
      default: () => {
        return []
      },
    },
    searchData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    loading: { type: Boolean, default: false },
    passList: {
      type: Array,
      default: () => {
        return []
      },
    },
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isHasExamed: { type: Number, default: 0 },
  },
  methods: {
    searchList() {
      this.$emit('searchList', this.searchData)
    },
    selectionChange(selection) {
      this.$emit('selectionChange', selection)
    },
    viewInfo(row) {
      this.$emit('viewInfo', row)
    },
    // download(sessionName) {
    //   this.$emit('download', { sessionName })
    // },
    downloadGrades() {
      this.$emit('downloadGrades') // 下载成绩单
    },
  },
}
</script>
